import { Component, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-virtuealert-modal',
    templateUrl: './virtuealert.component.html',
    styleUrls: ['./virtuealert.component.scss'],
})
export class VirtueAlertModalComponent {
    @ViewChild("virtueAlert") dialogTemplate:any;
    @ViewChild("virtuePaymnetAlert") virtuePaymnetAlertDialog:any;
    modalRef: BsModalRef;
    path: any;

    constructor(private modalService: BsModalService, private router: Router) {
        this.path = this.router.url;
      //  console.log(this.path);
     }
    show() {
        if (this.path === '/payment') {
            this.modalRef = this.modalService.show(this.virtuePaymnetAlertDialog);
        } else {
            this.modalRef = this.modalService.show(this.dialogTemplate);
        }
       
    }
    hide() {
        if (this.modalRef !== undefined)
            this.modalRef.hide();
    }
}